import { currencies } from "../constants/Constants";

export const getCurrencyLabel = (currency: string) => {
  return currencies.find((c) => c.value === currency)?.label || currency;
};
